<div class="dialog-header">
  <div class="header-right-side">
    <img src="./../../../../../../assets/images/close.svg" alt="close_svg" (click)="close()" />
  </div>
</div>

<h2 class="dialog-title">Integration Statistics</h2>
<p class="dialog-subtitle">Detailed analytics for your connected integrations</p>

<div class="stat-cards">
  <div class="stat-card">
    <div class="stat-value blue">{{ totalMessages | number }}</div>
    <div class="stat-label">Messages Processed</div>
  </div>
  <div class="stat-card">
    <div class="stat-value green">{{ uptime }}%</div>
    <div class="stat-label">Uptime</div>
  </div>
</div>

<h3 class="usage-title">Integration Usage</h3>

<div class="usage-row" *ngFor="let usage of usageData">
  <div class="usage-label">{{ usage.name }}</div>
  <div class="usage-bar-container">
    <div
      class="usage-bar-fill"
      [style.width.%]="(usage.value / maxValue) * 100"
    ></div>
  </div>
  <div class="usage-count">{{ usage.value }} msgs</div>
</div>

<div class="dialog-footer">
<button mat-button class="close-btn" (click)="close()">Close</button>
</div>
